<template>
  <v-dialog
    v-model="dialog"
    max-width="30rem"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <template v-slot:activator="{ on }">
      <v-list-item-content v-on="on">
        <v-list-item-subtitle>Clé de synchronisation</v-list-item-subtitle>
      </v-list-item-content>
    </template>
    <v-card>
      <v-card-title class="pa-1">
        <v-row dense no-gutters align="start" justify="end">
          <v-btn small icon text @click="dialog = !dialog">
            <v-icon small>fa-times</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text class="pb-0 pt-3" v-if="!loading">
        <v-text-field
          filled
          dense
          class="no-before"
          ref="input"
          :value="getStoreInfo.store_key"
          @change="v => (new_store_key = v)"
          label="Clé d'identification du magasin pour l'intégration"
          prepend-icon="fa-key"
        ></v-text-field>
      </v-card-text>
      <v-card-text v-else>
        <v-progress-linear color="primary" indeterminate></v-progress-linear>
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-row align="center" justify="end" no-gutters>
          <v-btn
            color="success"
            small
            :disabled="loading"
            @click="updateStoreKey"
          >
            <v-icon small left>fa-save</v-icon>Enregistrer
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { api } from "@/api";
import { mapGetters } from "vuex";
export default {
  name: "UserStoreKeyEditor",
  computed: {
    ...mapGetters(["getStoreId", "getStoreInfo"])
  },
  data() {
    return {
      loading: false,
      dialog: false,
      new_store_key: ""
    };
  },
  methods: {
    async updateStoreKey() {
      try {
        this.loading = true;
        const data = {
          ...this.getStoreInfo,
          store_key: this.new_store_key
        };
        const res = await api.patchStore(this.getStoreId, data);
        this.$store.commit("setStoreKey", res.store_key);
        this.dialog = false;
      } finally {
        this.loading = false;
      }
    }
  },
  watch: {
    dialog(v) {
      if (v === false) {
        this.new_store_key = "";
      } else {
        setTimeout(() => this.$refs.input.focus(), 100);
      }
    }
  }
};
</script>

<style></style>
